import { HStack } from '@euler/components/layout/Stack';
import { kOrderFieldNoValuePlaceHolder } from '@euler/functions/order/constants';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Maybe } from '@euler/types';
import { parseTagsFromString } from '@euler/utils';
import { uniq } from '@euler/utils/array';
import { memo, useMemo } from 'react';
import { OrderTagPill } from '../OrderTagPill';
import {
  OrderSummaryInfoRow,
  OrderSummaryInfoRowProps,
} from './SummaryInfoRow';

export const OrderTagsInfoRow = memo(
  ({
    value,
    contentStyle,
    ...props
  }: Omit<
    OrderSummaryInfoRowProps<Maybe<string | string[]>>,
    'label' | 'copyable' | 'note' | 'format' | 'valid' | 'children'
  >) => {
    const { rpx } = useResponsiveContext();
    const tags = useMemo(
      () => (typeof value === 'string' ? parseTagsFromString(value) : value),
      [value],
    );

    return (
      <OrderSummaryInfoRow
        label="业务类型"
        value={value}
        mb={rpx(2)}
        alignItems="flex-start"
        contentStyle={[{ flexGrow: 1, flexBasis: 1 }, contentStyle]}
        fallbackText={kOrderFieldNoValuePlaceHolder}
        format={() => tags?.join('/') || kOrderFieldNoValuePlaceHolder}
        {...props}
      >
        {tags?.length ? (
          <HStack
            justifyContent="flex-start"
            flexWrap="wrap"
            flex={1}
            alignItems="flex-start"
            top={rpx(-1)}
          >
            {uniq(tags).map(tag => (
              <OrderTagPill
                tag={tag}
                key={tag}
                mr={rpx(4)}
                height={rpx(20)}
                borderRadius={rpx(10)}
                borderColor="#ccc"
                textStyle={{
                  fontSize: rpx(11),
                  lineHeight: rpx(16),
                }}
              />
            ))}
          </HStack>
        ) : null}
      </OrderSummaryInfoRow>
    );
  },
);
